'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formUpload = require('./form-upload');

var _formUpload2 = _interopRequireDefault(_formUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webPublicClient.creditRequest.shared.services', []).service('formUpload', _formUpload2.default);


// WEBPACK FOOTER //
// ./src/credit-request/shared/services/index.js